
export function formatRoleName(role: string) {
    let roleName = role;
    if (role != null && role.match(/[A-Z][a-z]+|[0-9]+/g) != null) {
      roleName = role.match(/[A-Z][a-z]+|[0-9]+/g).join(" ");
    }
    return roleName;
}